(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["desson-virtual-tryon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('desson-tryon')) {
  customElements.define('desson-tryon', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.dialog = this.querySelector('dialog');
      this.entry = this.querySelector('.desson-tryon__entry');
      this.help = this.querySelector('[data-help]');
      this.helpText = this.help.textContent;
      this.loading = this.querySelector('[data-loading]');
      this.loadingMessage = this.querySelector('[data-loading-text]');
      this.loadingText = this.loadingMessage.textContent;
      this.recovery = this.querySelector('[data-recovery]');
      this.frameSlot = this.querySelector('[data-frame-slot]');
      // Use the native link: standalone try-on works where iframe loading fails.
      this.querySelector('.desson-tryon__close').addEventListener('click', () => this.close(), options);
      this.querySelectorAll('[data-separate], [data-recovery-separate]').forEach(link => link.addEventListener('click', () => this.close(), options));
      this.querySelector('[data-retry]').addEventListener('click', () => this.loadFrame(), options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('close', () => this.cleanup(), options);
      window.addEventListener('message', event => {
        if (!this.frame || event.source !== this.frame.contentWindow || event.origin !== this.frameOrigin || event.data?.source !== 'eyewear-tryon') return;
        if (event.data.type === 'tryon:ready') {
          clearTimeout(this.timer);
          this.loading.hidden = true;
          this.recovery.hidden = true;
          this.frameSlot.setAttribute('aria-busy', 'false');
        }
        if (event.data.type === 'tryon:close') this.close();
        if (event.data.type === 'tryon:error') this.help.textContent = this.querySelector('[data-unavailable]').content.textContent;
      }, options);
      window.addEventListener('pagehide', () => this.cleanup(), options);
    }
    open() {
      if (this.dialog.open) return;
      this.previousOverflow = document.body.style.overflow;
      this.locked = true;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      this.loadFrame();
    }
    loadFrame() {
      if (!this.dialog.open) return;
      clearTimeout(this.timer);
      this.removeFrame();
      this.help.textContent = this.helpText;
      this.loadingMessage.textContent = this.loadingText;
      this.loading.hidden = false;
      this.recovery.hidden = true;
      this.frameSlot.setAttribute('aria-busy', 'true');
      const url = new URL(this.entry.href);
      url.searchParams.set('embed', '1');
      url.searchParams.set('parentOrigin', location.origin);
      this.frameOrigin = url.origin;
      this.frame = document.createElement('iframe');
      this.frame.title = this.querySelector('h2').textContent;
      this.frame.allow = 'camera';
      this.frame.referrerPolicy = 'strict-origin-when-cross-origin';
      this.frame.src = url.href;
      const frame = this.frame;
      frame.addEventListener('error', () => {
        if (this.frame === frame) this.failLoading();
      }, {once:true});
      this.timer = setTimeout(() => {
        if (this.frame === frame) this.failLoading();
      }, 20000);
      this.frameSlot.append(frame);
    }
    failLoading() {
      if (!this.frame || !this.dialog.open) return;
      clearTimeout(this.timer);
      this.loadingMessage.textContent = this.querySelector('[data-load-failed]').content.textContent;
      this.loading.hidden = false;
      this.recovery.hidden = false;
      this.frameSlot.setAttribute('aria-busy', 'false');
    }
    close() {
      this.dialog.close();
      this.cleanup();
    }
    cleanup() {
      clearTimeout(this.timer);
      this.frameSlot?.setAttribute('aria-busy', 'false');
      this.removeFrame();
      if (this.locked) {
        document.body.style.overflow = this.previousOverflow;
        this.locked = false;
        if (this.isConnected) this.entry.focus({preventScroll:true});
      }
    }
    removeFrame() {
      if (this.frame) {
        this.frame.contentWindow?.postMessage({source:'eyewear-host',type:'tryon:stop'},this.frameOrigin);
        this.frame.remove();
        this.frame = null;
      }
    }
    disconnectedCallback() {
      this.cleanup();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
